import BaseController from '../..';
import { document } from '../../../../models/entities/common_subentities/document';
import IPurchaseDemandDocuments from './IPurchaseDemandDocuments';

export default class PurchaseDemandDocuments extends BaseController implements IPurchaseDemandDocuments {
    constructor(baseUrl: string) {
        super(baseUrl);
    }
    async fetchPurchaseDemandDocuments(purchaseDemandNumber: string) {
        const response = await this.client.get(`/purchaseDemand/documents/${purchaseDemandNumber}`);
        return response;
    }
    async createMultiplePurchaseDemandDocument(purchaseDemandId: string, data: Array<document>) {
        this.client.setBodyType('FORM-DATA');
        const response = await this.client.post(`/purchaseDemand/documents/upload-multiple`, this.convertToArrayFormData(data, purchaseDemandId));
        return response;
    }
    async createPurchaseDemandDocument(purchaseDemandId: string, data: document) {
        this.client.setBodyType('FORM-DATA');
        const response = await this.client.post(`/purchaseDemand/documents/upload`, this.convertToFormData(data, purchaseDemandId));
        return response;
    }
    async updatePurchaseDemandDocument(purchaseDemandId: string, data: document) {
        this.client.setBodyType('FORM-DATA');
        const response = await this.client.put(`/purchaseDemand/documents`, this.convertToFormData(data, purchaseDemandId));
        return response;
    }
    async deletePurchaseDemandDocument(purchaseDemandId: string, documentId: number) {
        const response = await this.client.delete(`/purchaseDemand/documents`, JSON.stringify({ purchaseDemandId, id: documentId }));
        return response;
    }
    private convertToFormData(document: document, purchaseDemandId: string): FormData {
        const formData = new FormData();
        let type = document.type;
        if (Array.isArray(type)) type = JSON.stringify(type);
        formData.append('purchaseDemandId', purchaseDemandId);
        formData.append('type', type);
        formData.append('comment', document.comment);
        formData.append('fileName', document.fileName);
        formData.append('fileType', document.fileType);
        if (document.expDate) formData.append('expDate', JSON.stringify(document.expDate));
        if (document.file) formData.append('file', document.file);
        if (document.id) formData.append('id', '' + document.id);
        return formData;
    }
    private convertToArrayFormData(documents: Array<document>, purchaseDemandId: string): FormData {
        const formData = new FormData();
        formData.append('purchaseDemandId', purchaseDemandId);
        documents.forEach((document) => {
            let type = document.type;
            if (Array.isArray(type)) type = JSON.stringify(type);
            formData.append('type[]', type);
            formData.append('comment[]', document.comment);
            formData.append('fileName[]', document.fileName);
            formData.append('fileType[]', document.fileType);
            if (document.expDate) formData.append('expDate[]', JSON.stringify(document.expDate));
            if (document.file) formData.append('file[]', document.file);
            if (document.id) formData.append('id[]', '' + document.id);
        });
        return formData;
    }
}
